import { useQuery } from "@tanstack/react-query";
import { authenticatedGet, authenticatedPut } from "../../api/authenticatedFetch";

const URL = "/api/v1/forecast-predictability/auto-promote";

export function useAutoPromote() {
  return useQuery({
    queryKey: ["auto-promote"],
    queryFn: () => authenticatedGet(URL),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

// setAutoPromoteEnabled flips the per-customer kill switch (value is numeric 1/0).
export const setAutoPromoteEnabled = (on) =>
  authenticatedPut("/api/v1/application-parameters/forecast.auto_promote_enabled", { value: on ? 1 : 0 });
